"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEditor = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_hot_keys_1 = __importDefault(require("react-hot-keys"));
const configContext_1 = require("../../context/configContext");
const tenantLoader = __importStar(require("../../models/helper/tenantLoader"));
const useFirestore_1 = require("../../utils/useFirestore");
const usePrompt_1 = require("../../utils/usePrompt");
const validationUtils = __importStar(require("../../utils/validationUtils"));
const ValidationErrors_1 = require("../ValidationErrors");
const IconClear_1 = require("../icons/IconClear");
const IconSave_1 = require("../icons/IconSave");
const SimpleModal_1 = require("../simple-modal/SimpleModal");
const Spinner_1 = require("../spinner/Spinner");
const UserMembershipToggleButton_1 = require("../user-membership-toggle-button/UserMembershipToggleButton");
require("./UserEditor.scss");
class ValidationErrorsUserEditor extends ValidationErrors_1.ValidationErrors {
    constructor() {
        super(...arguments);
        this.nameInvalid = "";
        this.emailWrongFormat = "";
    }
}
const UserEditor = (props) => {
    const firestore = (0, useFirestore_1.useFirestore)();
    const config = (0, configContext_1.useConfig)();
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    // Use a clone of the user.
    const [userClone, setUserClone] = (0, react_1.useState)((0, cloneDeep_1.default)(props.user));
    // Update clone when user in props changes.
    (0, react_1.useEffect)(() => { }, [props.user]);
    // Validate when user clone changes.
    (0, react_1.useEffect)(() => {
        setValidationErrors(validate(userClone));
    }, [userClone]);
    const [showErrors, setShowErrors] = (0, react_1.useState)(false);
    const [validationErrors, setValidationErrors] = (0, react_1.useState)(new ValidationErrorsUserEditor());
    const [isDirty, setIsDirty] = (0, react_1.useState)(false);
    // Block navigation if there are any unsaved changes.
    (0, usePrompt_1.usePrompt)({
        when: isDirty,
        message: "Manche Änderungen wurden noch nicht gespeichert. Änderungen verwerfen und weiter?",
    });
    const [tenants, setTenants] = (0, react_1.useState)();
    const [tenantsLoading, setTenantsLoading] = (0, react_1.useState)(false);
    // Load tenants the user is a member of (to get full tenant names).
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        async function loadTenants() {
            setTenantsLoading(true);
            if (props.user.isSuperadmin) {
                setTenants(await tenantLoader.loadAllTenants(firestore));
            }
            else {
                setTenants(await tenantLoader.loadTenants(firestore, props.user.memberOf));
            }
            setTenantsLoading(false);
        }
        loadTenants();
        return () => abortController.abort();
    }, [props.user]);
    function handleUserChange(newUser) {
        const newUserClone = Object.assign((0, cloneDeep_1.default)(userClone), newUser);
        setUserClone(newUserClone);
        setIsDirty(!(0, isEqual_1.default)(newUserClone, props.user));
    }
    async function handleSave() {
        if (!showErrors) {
            // User clicked button. Show validation on next render.
            setShowErrors(true);
        }
        if (!validationErrors.hasErrors()) {
            // Show confirmation dialog when user changed memberships.
            if (!(0, isEqual_1.default)(props.user.memberOf, userClone.memberOf) ||
                !(0, isEqual_1.default)(props.user.adminOf, userClone.adminOf)) {
                showModal(react_1.default.createElement(SimpleModal_1.SimpleModal, { title: "\uD83D\uDE2E Mitgliedschaften entfernen?", body: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", null, "Soll ich die roten Mitgliedschaften wirklich entfernen?")), onClose: hideModal, onOk: () => {
                        props.onSave(userClone);
                        hideModal();
                    } }));
            }
            else {
                props.onSave(userClone);
            }
        }
    }
    function handleClose() {
        props.onClose();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container_1.default, { className: "user-editor" },
            react_1.default.createElement("div", { className: "d-flex justify-content-between mt-3" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h1", { className: "mb-0" }, userClone.id ? "Profil" : "Neuer Benutzer"),
                    react_1.default.createElement("div", { className: "text-warning", style: { minHeight: "1.5em", lineHeight: "1.4" } }, isDirty && "ungespeicherte Änderungen")),
                react_1.default.createElement("div", { className: "text-right no-print" },
                    react_1.default.createElement(Button_1.default, { variant: "primary", className: "my-1 text-nowrap", style: { minWidth: "125px" }, onClick: (e) => {
                            e.preventDefault();
                            handleSave();
                        }, title: "Speichern (ctrl+s)", disabled: !isDirty || (showErrors && validationErrors.hasErrors()) },
                        react_1.default.createElement(IconSave_1.IconSave, null),
                        " Speichern"),
                    " ",
                    react_1.default.createElement(Button_1.default, { variant: "secondary", className: "my-1 text-nowrap", style: { minWidth: "125px" }, onClick: handleClose },
                        react_1.default.createElement(IconClear_1.IconClear, null),
                        " Schliessen"))),
            props.errorEmailExists && (react_1.default.createElement(react_bootstrap_1.Alert, { className: "mt-3", variant: "danger" },
                "E-Mail ung\u00FCltig: Ein Benutzer mit E-Mail ",
                props.errorEmailExists,
                " ",
                "existiert bereits.")),
            react_1.default.createElement(Card_1.default, null,
                react_1.default.createElement(Card_1.default.Body, null,
                    react_1.default.createElement(Form_1.default.Group, { controlId: "name" },
                        react_1.default.createElement(Form_1.default.Label, null, "Vor- und Nachname"),
                        react_1.default.createElement(Form_1.default.Control, { type: "text", value: userClone.name, onChange: (e) => handleUserChange({ name: e.target.value }), isInvalid: showErrors && validationErrors.nameInvalid !== "" }),
                        react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.nameInvalid)),
                    react_1.default.createElement(Form_1.default.Group, { controlId: "email" },
                        react_1.default.createElement(Form_1.default.Label, null, "E-Mail"),
                        react_1.default.createElement(Form_1.default.Control, { type: "email", value: userClone.email, onChange: (e) => handleUserChange({ email: e.target.value }), isInvalid: showErrors && validationErrors.emailWrongFormat !== "" }),
                        react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.emailWrongFormat)),
                    react_1.default.createElement(Form_1.default.Group, { controlId: "membership" },
                        react_1.default.createElement(Form_1.default.Label, null, "Mitgliedschaften"),
                        tenantsLoading || tenants === undefined ? (react_1.default.createElement(Spinner_1.Spinner, { className: "mt-2" })) : (react_1.default.createElement(react_bootstrap_1.ListGroup, null, props.user.memberOf.map((tenantId) => {
                            const tenant = tenants.find((t) => t.id === tenantId);
                            const isActive = config.tenantId === tenantId;
                            if (!tenant) {
                                throw new Error(`Could not find tenant ${tenantId}`);
                            }
                            return (react_1.default.createElement(react_bootstrap_1.ListGroup.Item, { key: tenant.id, className: "d-flex justify-content-between align-items-center" },
                                react_1.default.createElement("a", { href: `/manager/${tenantId}/users/me/`, className: "text-reset" + (isActive ? " strong" : "") }, tenant.name),
                                react_1.default.createElement("div", null,
                                    props.user.isAdminOf(tenant.id) && (react_1.default.createElement(UserMembershipToggleButton_1.UserMembeshipToggleButton, { className: "mr-2", label: "Admin", titleAdd: "Admin hinzuf\u00FCgen", titleRemove: "Admin entfernen", checked: userClone.isAdminOf(tenant.id), onAdd: () => {
                                            handleUserChange({
                                                adminOf: [...userClone.adminOf, tenant.id],
                                                // Also add membership if admin is added.
                                                memberOf: [...userClone.memberOf, tenant.id],
                                            });
                                        }, onRemove: () => {
                                            handleUserChange({
                                                adminOf: userClone.adminOf.filter((t) => t !== tenant.id),
                                            });
                                        } })),
                                    react_1.default.createElement(UserMembershipToggleButton_1.UserMembeshipToggleButton, { className: "mr-2", label: "Mitglied", titleAdd: "Mitgliedschaft hinzuf\u00FCgen", titleRemove: "Mitgliedschaft entfernen", checked: userClone.isMemberOf(tenant.id), onAdd: () => {
                                            handleUserChange({
                                                memberOf: [...userClone.memberOf, tenant.id],
                                            });
                                        }, onRemove: () => {
                                            handleUserChange({
                                                memberOf: userClone.memberOf.filter((t) => t !== tenant.id),
                                                // Also remove admin if membership is removed.
                                                adminOf: userClone.adminOf.filter((t) => t !== tenant.id),
                                            });
                                        } }))));
                        }))),
                        props.user.memberOf.length === 0 && (react_1.default.createElement("div", { className: "italics" }, "Keine Mitgliedschaften"))),
                    props.user.isSuperadmin && (react_1.default.createElement(Form_1.default.Group, { controlId: "superadmin" },
                        react_1.default.createElement(Form_1.default.Label, null, "Superadmin"),
                        react_1.default.createElement("div", null, "\uD83E\uDDB8 Du hast Superkr\u00E4fte!")))))),
        react_1.default.createElement(react_hot_keys_1.default, { keyName: "ctrl+s,command+s", onKeyDown: (shortcut, evn, handle) => {
                evn.preventDefault();
                handleSave();
            }, filter: (event) => true }),
        react_1.default.createElement(react_hot_keys_1.default, { keyName: "esc", onKeyDown: (shortcut, evn, handle) => {
                const modalOpen = document.body.classList.contains("modal-open");
                if (!modalOpen) {
                    evn.preventDefault();
                    handleClose();
                }
            }, filter: (event) => true }),
        modal));
};
exports.UserEditor = UserEditor;
function validate(user) {
    const errors = new ValidationErrorsUserEditor();
    if (user.name.trim().length < 5) {
        errors.nameInvalid = "Bitte gültigen Namen angeben.";
    }
    if (!validationUtils.validEmail(user.email)) {
        errors.emailWrongFormat = "Bitte gültige E-Mail Adresse angeben.";
    }
    return errors;
}
